export const getReportsHomePathForRoute = (pathname) =>
  String(pathname || "").startsWith("/superadmin/reports")
    ? "/superadmin/reports"
    : "/manager/reports";

export const getReportPathForRoute = (pathname, managerPath) =>
  String(pathname || "").startsWith("/superadmin/reports")
    ? String(managerPath || "").replace("/manager/reports", "/superadmin/reports")
    : managerPath;
